var map = {
	"./3ddata.svg": 174,
	"./3djobs.svg": 175,
	"./3dmaintenance.svg": 176,
	"./3dpaas.svg": 177,
	"./Analytics.svg": 178,
	"./account.svg": 179,
	"./admin.svg": 180,
	"./anacreon.svg": 181,
	"./area51.svg": 182,
	"./autoflow.svg": 183,
	"./blacksea-portal.svg": 184,
	"./box.svg": 185,
	"./color-config.svg": 186,
	"./composer.svg": 187,
	"./control_tower.svg": 188,
	"./da-vinci.svg": 189,
	"./devices.svg": 190,
	"./di.svg": 191,
	"./dscoop.svg": 192,
	"./epm-preflight-admin.svg": 193,
	"./epm-preflight.svg": 194,
	"./go3d.svg": 195,
	"./home.svg": 196,
	"./imposer.svg": 197,
	"./indigo-events.svg": 198,
	"./jobs.svg": 199,
	"./jobs_2.svg": 200,
	"./knowledge-zone.svg": 201,
	"./lkc.svg": 202,
	"./locr-maps.svg": 203,
	"./market-admin.svg": 204,
	"./marketplace.svg": 205,
	"./media-locator.svg": 206,
	"./myknowledge.svg": 207,
	"./packzalyzer.svg": 208,
	"./pc-reporter.svg": 209,
	"./ppc.svg": 210,
	"./press-security.svg": 211,
	"./print-beat.svg": 212,
	"./pwicfa.svg": 213,
	"./ready2print.svg": 214,
	"./reseller_portal.svg": 215,
	"./resource-manager.svg": 216,
	"./service-calls.svg": 217,
	"./sim.svg": 218,
	"./site-flow.svg": 219,
	"./softproof.svg": 220,
	"./substrate-manager.svg": 221,
	"./supplies_and_parts.svg": 222,
	"./takeback_menu.svg": 223,
	"./university.svg": 224,
	"./valid3d.svg": 225,
	"./wallart.svg": 226
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85;



//////////////////
// WEBPACK FOOTER
// ../~/@printos/gazelle/src/mini-apps/app-switcher/icons ../~/html-loader!\.svg$
// module id = 85
// module chunks = 0